import React from 'react';
import Helmet from 'react-helmet';

export const Head: React.FC = () => (
  <Helmet>
    <title>Alvéole</title>
  </Helmet>
);
